const navigation = document.querySelector('.navigation')

document.addEventListener('alpine:init', () => {
    Alpine.data('navigation', () => ({
        atTop: false,
        isOpen: false,

        // Allow use of Esc key to close nav
        close: {
            ['@keydown.window.escape']() {
                this.isOpen = false
            },
        },

        // Enable class swap when leaving top
        // :class="{ '--shrunk': atTop }" x-bind="scroll"
        scroll: {
            ['@scroll.window']() {
                this.atTop = (window.scrollY < 61) ? false: true
            },
        },

        toggle() {
            this.isOpen = ! this.isOpen
        },
    }))
})
